import type { AppSelectOption } from '@shared/form-fields/options/select-option';
import type { Team } from '@shared/modules/teams/team';

export const EVENT_SELECTED_TEAMS_LOADED = 'app:teams-loaded';
export const EVENT_SELECTED_TEAMS_CHANGED = 'app:teams-changed';

export const allTeamsId = 'all';
export const allTeamsValue: Readonly<Team> = ({ id: allTeamsId, description: 'All Teams' });
export const allTeamsOption: AppSelectOption<Team> = Object.freeze({ label: 'All teams', value: allTeamsValue });
